import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslations from '../locales/en/translation.json';
import arTranslations from '../locales/ar/translation.json';
import enAdminTranslations from './locales/en.json';
import arAdminTranslations from './locales/ar.json';

// Merge translations - admin translations should take precedence
const enResources = {
    translation: {
        ...enTranslations,
        ...enAdminTranslations  // Admin translations override common translations
    }
};

const arResources = {
    translation: {
        ...arTranslations,
        ...arAdminTranslations  // Admin translations override common translations
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: enResources,
            ar: arResources,
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n; 